import React, {useCallback, useState, useEffect} from 'react'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import {useDispatch, useSelector} from 'react-redux'
import endpoints, {apiRequest} from '../../../endpoints'
import axios from 'axios'
import Chart from "react-apexcharts"
import moment from 'moment'
import LoadingSmall from '../parts/LoadingSmall'

export default function LoadFeeds(props) {
    const [range, setRange] = useState('week')
    const [loading, setLoading] = useState(false)
        
    const token = useSelector((state) => state.auth.token)
    
    const [chart, setChart] = useState(() => {
        return {options: {}, series: []}
    })
        
    const getChart = async () => {
        setLoading(true)
        try {
            const dateTo = moment().endOf('day')
            const dateFrom = moment().subtract(1, range).startOf('day')
            
            const res = await apiRequest('get', endpoints.feeds_load, {
                token: token,
                datefrom: dateFrom.toISOString(),
                dateto: dateTo.toISOString(),
                frequency: range == 'year' ? 'month' : 'day',
            }, false)
            
            if (res.data.status == 'success') {
                let series = []
                res.data.feeds.map((feed) => {
                    let data = []
                    feed.items.map((item) => {
                        data.push({
                            x: moment(item.time).local().valueOf(),
                            y: item.count
                        })
                    })
                    
                    let ser = {
                        name: feed.name,
                        data: data
                    }
                    series.push(ser)
                })

                setChart({
                    options: {
                        dataLabels: {
                            enabled: false,
                        },
                        chart: {
                            toolbar: {
                                show: false,
                            },
                            zoom: false,
                        },
                        xaxis: {
                            type: 'datetime',
                            labels: {
                                format: 'dd/MM',
                                datetimeUTC: false,
                            },
                            min: dateFrom.valueOf(),
                            max: dateTo.valueOf(),
                        }
                    },
                    series: series
                })
            }
        } catch (e) {
            //
        }
        setLoading(false)
    }
    
    const feedsUpdatedHandler = () => {
        getChart()
    }
    
    useEffect(() => {
        getChart()
    }, [range])
    
    useEffect(() => {
        getChart()
        
        window.removeEventListener('FEEDS_CONTENTS_UPDATED', feedsUpdatedHandler)
        window.addEventListener('FEEDS_CONTENTS_UPDATED', feedsUpdatedHandler)
    }, [])
        
    return (
        <Paper sx={{height:270, position: 'relative',}}>
            <Stack sx={{position: 'relative', overflow: 'hidden'}}>
                <Stack direction="row" sx={{pl: 3, pt: 1.5, flexGrow:1, maxWidth: '100%'}}>
                    <Typography variant="subtitle1" sx={{pt:0.5, flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        Feeds Loading
                    </Typography>
                    <RadioGroup 
                        row sx={{pt: 2}}
                        value={range}
                        sx={{flexWrap: 'nowrap'}}
                        onChange={(e) => {setRange(e.target.value)}}
                    >
                        <FormControlLabel value="year" control={<Radio size="small" />} label="Year" />
                        <FormControlLabel value="month" control={<Radio size="small" />} label="Month" />
                        <FormControlLabel value="week" control={<Radio size="small" />} label="Week" />
                    </RadioGroup>
                </Stack>
                <Chart
                    options={chart.options}
                    series={chart.series}
                    type="bar"
                    height={200}
                />
            </Stack>
            { loading ? <LoadingSmall /> : null }
        </Paper>
    )
}